export default {
  packs: {
    packListTab: {
      title: "Pack List",
      reasonReturningPackForm: {
        modal: {
          title: "Reason for returning the package",
          form: {
            reasons: "Reasons"
          }
        }
      },
      alert: {
        postingAllPrepare: "There are no packs to carry.",
        lastMessagePackVerification: {
          verificationCompleted: "Verification completed.",
          checked: "Checked",
          bugsFound: "Errors found:"
        },
        postingAllContinue: "Bundle delivery completed"
      },
      confirm: {
        postingPrepare: "Spread the selected pack on the front?",
        postingAllPrepare: {
          messageCountPacks: "Number of packs to posting",
          messagePostingAll: "Start posting packs to posting?"
        },
        onReturnBtn:
          "Determine the fallacy of the selected pack and send it to an accountant?",
        onPostponeBtn:
          "Set aside a selected batch for automatic posting at night?",
        onPostingAllBtn: "Spread all correctly filled packs on the front?"
      }
    },
    packSelectedTab: {
      title: "Pack No.",
      countbandsEditForm: {
        modal: {
          title: {
            payments: "Countband",
            subsidies: "List"
          }
        },
        form: {
          number: {
            payments: "Countband number",
            subsidies: "List number"
          },
          quantity: {
            payments: "Number of receipts",
            subsidies: "Number of subscribers"
          },
          totalSum: "Total amount"
        }
      },
      countbandsName: {
        payments: "Countbands",
        subsidies: "Lists"
      },
      oneCountbandName: {
        payments: "Countband No.",
        subsidies: "List No."
      },
      countbandsTotal: {
        pack: "By pack",
        payments: {
          countband: "By parcel",
          countbands: "By parcels",
          receipts: "By receipts"
        },
        subsidies: {
          list: "By sheet",
          lists: "By sheets",
          socials: "By subsidies/soc.benefits"
        }
      },
      paymentTitle: {
        compensationForVisuallyImpaired:
          "Compensation for the visually impaired S: {countband} R: {receipt}",
        socialSurcharge: "Social surcharge S: {countband} R: {receipt}",
        subsidy: "Subsidy S: {countband} R: {receipt}",
        receipt: "Receipt P: {countband} R: {receipt}"
      },
      alert: {
        importPackIsNotChanged: "Imported pack data cannot be changed",
        maxCountbandsHasAlreadyBeenEntered:
          "The required number of parcels has already been entered",
        maxListsHasAlreadyBeenEntered:
          "The required number of sheets has already been entered",
        deleteCountband: "Remove the parcel?",
        deleteList: "Delete sheet?",
        maxReceiptsHasAlreadyBeenEntered:
          "The required number of receipts has already been entered",
        maxSubsidiesHasAlreadyBeenEntered:
          "The required number of subsidies has already been entered"
      },
      confirm: {
        deletePayment: "Delete payment?",
        deleteAllCountband: "Delete the contents of the parcel?",
        deleteAllList: "Delete sheet content?"
      }
    }
  }
};
